export const locale = {
    lang: 'de',
    data: {
      'WEB_COMPANY_PROFILE': {
        'TIT_WCP': 'Web-Firmenprofil',
        'TIT_WCP_DAT': 'Zugangsdaten',
        'CHAN_INF':'Ladeinformationen',
        'HELP':'Hilfe',
        'EnlaceWCP':'Link kopieren, um zum Unternehmensprofil zu gelangen',
        'ClaveWCP':'Kopieren Sie das Passwort für den Zugang zum Unternehmensprofil',
        'PORDUC_CER':{
          '40':'Certify 3.0',
          '1':'Certify',
          '20':'Zertifizieren 2.0',
        },
        'ESTA_WEB_CP':{
          'false':'Ich veröffentliche nicht',
          'true':'Öffentlich',
        },
        'MODAL':{
          'TIT_MOD':'Was ist der Grund für die Nichtveröffentlichung?',
          'BTN_CONT':'Weiter',
          'BTN_CANC':'Abbrechen',
          'RAISON_OBLIG': 'Um fortzufahren, müssen Sie den Grund für die Nichtveröffentlichung angeben',
          'TIT_CONDI_US':'Nutzungsbedingungen',
          'TEX1_CONDI_US':'Wenn das Unternehmensprofil öffentlich gemacht wird, wird es auf der Great Place To Work(r)-Seite mit den konfigurierten Informationen veröffentlicht. Great Place to Work(r) ist nicht für den Inhalt verantwortlich, da die veröffentlichten Daten das Ergebnis von Informationen sind, die das Unternehmen selbst auf die dafür vorgesehenen Plattformen hochgeladen hat.',
          'TEX2_CONDI_US':'Das Unternehmen erklärt sich außerdem damit einverstanden, dass diese Informationen in die verschiedenen Suchmaschinen hochgeladen werden, die beauftragt wurden, die Verbreitung der von Great Place To Work(r) zertifizierten besten Arbeitgeber zu fördern',
          'TEX3_CONDI_US':'Das Unternehmen kann das Unternehmensprofil jederzeit in den privaten Modus zurückversetzen, wodurch es nicht mehr in der Liste der zertifizierten Unternehmen erscheint. Great Place To Work(r) kann jedoch die Indizierung, die die Suchmaschinen vorgenommen haben, nicht entfernen, so dass der Unternehmensname wahrscheinlich noch eine Zeit lang in den Suchergebnissen der verschiedenen Suchmaschinen, mit denen Great Place To Work zusammenarbeitet, erscheinen wird',
          'TEX4_CONDI_US':'Für die Veröffentlichung oder Nichtveröffentlichung dieses Unternehmensprofils ist allein das Unternehmen verantwortlich.',
          'REA_TEX_CONDI_US':'Zur Bestätigung schreiben Sie bitte den folgenden Text',
          'NO_DISPO_ARCHI':'Die Datei ist nicht verfügbar',
        }

      }
    }
};
